import React, {useState} from 'react'
import {JsonView} from 'react-json-view-lite'
import ContainerLayout from './ContainerLayout'
import WizButton from '../button/WizButton'

interface IProps {
    className?: string
    title?: string
    data?: Record<string, unknown>
}

// 화면에 정식 섹션으로 뽑지 않은 필드까지 확인하기 위한 응답 원본 뷰어.
// 스타일은 KeySubInfoContainer의 JsonView 설정과 동일하게 맞췄다.
const jsonViewStyle = {
    basicChildStyle: '',
    booleanValue: 'text-gray-400',
    container: '',
    expander: '',
    label: 'text-black-700',
    nullValue: 'text-red-500',
    numberValue: 'text-blue-400',
    otherValue: '',
    pointer: '',
    punctuation: '',
    stringValue: 'text-yellow-600',
    undefinedValue: 'text-orange-500',
}

const RawJsonContainer: React.FC<IProps> = ({className, title = 'API Response (Raw)', data}) => {
    const [isOpen, setIsOpen] = useState(false)

    if (data === undefined) {
        return null
    }

    return (
        <ContainerLayout title={title} className={className} containerClassName={'space-y-[15px]'}>
            <WizButton
                text={isOpen ? 'Hide' : 'Show'}
                size={'small'}
                type={'blue'}
                onClick={() => setIsOpen(!isOpen)}
            />
            {isOpen && (
                <div className={'overflow-x-auto text-body3'}>
                    <JsonView data={data} style={jsonViewStyle} />
                </div>
            )}
        </ContainerLayout>
    )
}

export default RawJsonContainer
